import React, { useState } from 'react';
import { Menu, Checkbox, Input, Button, Dropdown } from 'antd';
import { ReadOutlined, InfoCircleOutlined } from '@ant-design/icons';

const HeaderDrop = () => {
    const [selectedItems1, setSelectedItems1] = useState([]);
    const [inputValue, setInputValue] = useState("");



    const items = ['Turn on Utilities', 'Utilities Usage Reviews', 'Weekly Staff Inbox Check', 'Zillow Invoicing', 'Weekly Owner Email Update', 'Weekly Checking', 'Turn on Utilities', 'Utilities Usage Reviews', 'Weekly Staff Inbox Check', 'Zillow Invoicing', 'Weekly Owner Email Update', 'Weekly Checking'];

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleSelectItem = (item) => {
        setInputValue(item);
        setSelectedItems1((prevSelectedItems) => [...prevSelectedItems, item]);
    };

    const menu = (
        <Menu className='card-container-div' style={{ width: '230px', height: '300px' }}>
            <Menu.ItemGroup>
                <Checkbox.Group
                    value={selectedItems1}
                    onChange={(value) => setSelectedItems1(value)}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: 'transparent',
                        display: 'inline-block',
                        maxHeight: '270px',
                        overflowY: 'auto',
                        width: '218px',
                    }}
                >
                    <div style={{ position: 'sticky', top: '0', color: 'gray', zIndex: 1, background: 'none' }}>
                        <Input
                            placeholder="Type a variable name"
                            style={{ width: '100%', padding: '10px' }}
                            suffix={<InfoCircleOutlined />}
                            value={inputValue}
                            onChange={handleInputChange}
                            onPressEnter={(e) => {
                                e.preventDefault();
                                if (inputValue.trim() !== '') {
                                    handleSelectItem(inputValue.trim());
                                    setInputValue('');
                                }
                            }}
                        />
                        <p style={{ zIndex: 1, margin: '6px 2px', fontSize: '12px', fontWeight: 'bold' }} >GLOBAL VARIABLES</p>
                    </div>
                    <div>
                        {items.map((item, index) => (
                            <Menu.Item key={`item${index}`}>
                                <p onClick={() => handleSelectItem(item)}>{item}</p>
                            </Menu.Item>
                        ))}
                    </div>
                </Checkbox.Group>
            </Menu.ItemGroup>
        </Menu>
    );

    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <Button style={{ background: 'transparent', border: 'none' }} >
                <ReadOutlined />
            </Button>
        </Dropdown>
    );
};

export default HeaderDrop;
